<app-main-library-form [editItem]="editItem" [editItemType]="libraryEditItemTypes.EditTag" [existedTitles]="[]"
  (exit)="exit()">

  <ng-container content>
    @if (tag.AssignedMonitorKeys | findAssignedMonitors: monitorsService.allMonitors.getValue(); as assignedMonitors) {
      <p class="mt-3 mb-1">Assigned monitors</p>
      <ul class="items-list">
        @for (item of assignedMonitors; track item.MonitorHandler) {
          <li>
            <div (contextmenu)="$event.preventDefault()">
              <span [innerHTML]="item | monitorTitleOnly"></span>

              <mat-icon svgIcon="close" [matTooltip]="monitorTagDialogMessagesEnum.DeleteMonitorTagTitle"
                (click)="removeAssignedMonitor(item)">
              </mat-icon>
            </div>
          </li>
        }
      </ul>
    }
  </ng-container>

  <ng-container color-picker>
    <app-color-picker [(color)]="editItem.Color" [position]="'bottom'"></app-color-picker>
  </ng-container>

  <ng-container footer>
    <button class="playlist-submit" type="button" (click)="submit()" [disabled]="libraryFormComponent.form.invalid || isLoading">
      Finish
    </button>
  </ng-container>
</app-main-library-form>
